import { Fragment, useContext, useEffect, useReducer } from 'react'

import isMountStatus from '../../../../utils/isMountStatus'
import { DropdownWrapper } from '../../../DropDownStyles'
import { FilterBody } from '../../../FilterModal'
import { CANCEL, DONE } from '../../Constants'
import AdultCounter from './AdultsCounter'
import ChildrenAgeRender from './ChildrenAge'
import ChildrenCounter from './ChildrenCounter'
import { PaxAgeComponent } from './PaxAgeComponent'
import PaxAlert from './PaxAlert'
import { PAXContext } from './PaxContext'
import { PaxDetailsWrapper } from './PaxDetailsWrapper'
import PaxRoom from './PaxRoom'
import PaxState, { getInitialState } from './PaxState'
import RoomFooter from './RoomFooter'

const PaxComponent = ({
	onChange,
	filterBodyStyles,
	setCtaDisabled = () => null,
}) => {
	const [state] = useContext(PAXContext)

	const { costingInfo = [] } = state

	useEffect(() => {
		typeof onChange === 'function' && onChange(costingInfo)
	}, [costingInfo, onChange])

	useEffect(() => {
		let disabled = true
		costingInfo?.forEach(val => {
			if (!val.childAges?.length) {
				disabled = false
			} else {
				if (!val.childAges.includes(null)) {
					disabled = false
				} else {
					disabled = true
				}
			}
		})
		setCtaDisabled(disabled)
	}, [state])

	return (
		<Fragment>
			<PaxAlert />
			<FilterBody bottom={'48px'} style={filterBodyStyles || null}>
				<PaxRoom />
				<AdultCounter />
				<ChildrenCounter />
				<ChildrenAgeRender />
				<RoomFooter />
			</FilterBody>
		</Fragment>
	)
}

/**
 * Wrapper for getting Hotel Configuration info - This contains its own context
 * @param {boolean} noDropdown toggle the DropdownWrapper and footer options using this prop
 * @param {object} dropdownProps props for the DropdownWrapper
 * @param {function} onChangeAction - callback method to be triggered on each config change - works only if noDropdown is true
 * @param {function} successCallback callback method to be called on submit action - with final hotelConfig as param
 * @param {function} cancelCallback callback method to be called on cancel action - with unchanged hotelConfig as param
 * @param {function} commonCallback will be triggered on both submit & cancel action - with final/unchanged hotelConfig as param
 * @param {number} triggerSubmit externally trigger the submit action by passing different number
 * @param {boolean} triggerCancel externally trigger the cancel action by passing true
 * @param {object} hotelGuestRoomConfigurations hotelConfig object
 *
 * NOTE: If both triggerSubmit & triggerCancel are true then submit action will be triggered
 */
const PaxWrapper = ({
	noDropdown,
	dropdownProps = {},
	filterBodyStyles = {},
	wrapperStyles = {},
	onChangeAction,
	hotelGuestRoomConfigurations = [
		{
			adultCount: 2,
			childAges: [],
		},
	],
	commonCallback,
	successCallback,
	cancelCallback,
	triggerSubmit,
	triggerCancel,
	// isLeave,
	// setCustomBlurAction,
	showOnlyAgeField = false,
	setCtaDisabled,
	isPDG,
}) => {
	if (showOnlyAgeField) {
		hotelGuestRoomConfigurations = hotelGuestRoomConfigurations.map(
			roomDetail => {
				if (!roomDetail['adultAges']) {
					roomDetail['adultAges'] = Array.from(new Array(roomDetail.adultCount))
				}
				return roomDetail
			},
		)
	}

	const [store, dispatch] = useReducer(
		PaxState,
		hotelGuestRoomConfigurations,
		getInitialState,
	)

	const onSubmit = () => {
		dispatch({
			type: DONE,
			payload: {
				triggerAction: () => {
					// triggerBlurAction()
					typeof commonCallback === 'function' &&
						commonCallback(store.costingInfo)
					typeof successCallback === 'function' &&
						successCallback(store.costingInfo)
				},
				showOnlyAgeField: showOnlyAgeField,
			},
		})
	}

	const onCancel = () => {
		dispatch({
			type: CANCEL,
			payload: {
				triggerAction: costingValues => {
					// triggerBlurAction()
					typeof commonCallback === 'function' && commonCallback(costingValues)
					typeof cancelCallback === 'function' && cancelCallback(costingValues)
				},
			},
		})
	}

	const isMount = isMountStatus()
	useEffect(() => {
		if (!isMount) {
			if (triggerSubmit) {
				onSubmit()
			} else if (triggerCancel) {
				onCancel()
			}
		}
	}, [triggerCancel, triggerSubmit])

	return (
		<PAXContext.Provider value={[store, dispatch]}>
			{noDropdown ? (
				<PaxDetailsWrapper style={wrapperStyles || null}>
					{showOnlyAgeField ? (
						<PaxAgeComponent onChange={onChangeAction || function () {}} />
					) : (
						<PaxComponent
							setCtaDisabled={setCtaDisabled}
							filterBodyStyles={filterBodyStyles}
							onChange={onChangeAction || function () {}}
						/>
					)}
				</PaxDetailsWrapper>
			) : (
				<DropdownWrapper
					position={'absolute'}
					positionTop={'56px'}
					positionLeft={'-8px'}
					minHeight={'338px'}
					width={isPDG && '400px'}
					arrowLeft
					{...dropdownProps}
				>
					<PaxDetailsWrapper wrapperStyles={wrapperStyles || null}>
						{showOnlyAgeField ? (
							<PaxAgeComponent />
						) : (
							<PaxComponent
								setCtaDisabled={setCtaDisabled}
								filterBodyStyles={filterBodyStyles}
							/>
						)}
						{/* <FilterFooter minHeight={'48px'} padding={'12px 16px'}>
							<Footer
								successCallback={onSubmit}
								cancelCallback={onCancel}
								isLeave={isLeave}
								setCustomBlurAction={setCustomBlurAction}
							/>
						</FilterFooter> */}
					</PaxDetailsWrapper>
				</DropdownWrapper>
			)}
		</PAXContext.Provider>
	)
}

export default PaxWrapper
